import React,{useCallback,useEffect,useRef,useState} from 'react';
import Cookies from 'js-cookie';
import RefreshIconButton from './RefreshIconButton';
import UploadJobs from './UploadJobs';
import WorkspacePopup from './WorkspacePopup';
import {alertRequest} from './alertQueue';
import './DataWorkspace.css';
export default function UploadHistoryModal({isOpen,onClose}) {
 const reads=useRef(null),version=useRef(0);
 const [data,setData]=useState({rows:[],error:''}),[loading,setLoading]=useState(false);
 const user=Cookies.get('guid')||'',token=Cookies.get('token')||localStorage.getItem('token');
 const load=useCallback(async()=>{
  reads.current?.abort();const controller=new AbortController();reads.current=controller;const generation=++version.current;setLoading(true);
  try {
   if(!user||!token)throw new Error('Sign in again to view upload history.');
   const base=process.env.REACT_APP_CYBEDEFENDER_AI_URL||'/api';
   const rows=await alertRequest(base+'/cybedefender/upload-history?'+new URLSearchParams({userId:user}),token,{signal:controller.signal});
   if(!Array.isArray(rows))throw new Error('The server returned an unreadable upload history.');
   if(!controller.signal.aborted&&generation===version.current)setData({rows,error:''});
  }catch(error){if(!controller.signal.aborted&&generation===version.current)setData(previous=>({...previous,error:error.message||'Upload history could not be loaded.'}));}
  finally{if(!controller.signal.aborted&&generation===version.current)setLoading(false);}
 },[user,token]);
 useEffect(()=>{
  if(!isOpen)return undefined;
  setData({rows:[],error:''});load();
  const timer=setInterval(()=>{if(document.visibilityState==='visible')load();},15000);
  return()=>{clearInterval(timer);reads.current?.abort();version.current+=1;};
 },[isOpen,load]);
 return <WorkspacePopup isOpen={isOpen} title="Upload history" subtitle="Personal CSV jobs" closeLabel="Close upload history" onClose={onClose} actions={<RefreshIconButton onClick={load} loading={loading} label="Refresh upload history"/>}>
  <UploadJobs rows={data.rows} loading={loading} error={data.error}/>
 </WorkspacePopup>;
}
